import {Route, Routes} from 'react-router-dom'
import {PasswordRecovery} from '../pages/password-recovery'
import {SignIn} from '../pages/signin'
import {AuthLayout} from './AuthLayout'
import { PassworForgotten } from '../pages/password-forgotten'
import { PasswordSetup } from '../pages/password-setup'
import { SignUp } from '../pages/signup'
import { SignUpConfirmation } from '../pages/signup-confirmation'

const AuthRoutes = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='forgot-password' element={<PassworForgotten />} />
      <Route path='password-recovery' element={<PasswordRecovery />} />
      <Route path='password-setup' element={<PasswordSetup />} />
      <Route path='signin' element={<SignIn />} />
      <Route path='signup/confirmation' element={<SignUpConfirmation />} />
      <Route path='signup' element={<SignUp />} />
      <Route index element={<SignIn />} />
    </Route>
  </Routes>
)

export {AuthRoutes}
